import Box from '@mui/material/Box';
import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const StyledTypography = styled(Typography)({
  width: '100%',
  borderBottom: '1px solid #AAA',
  lineHeight: '0.1em',
  '& span': {
    background: '#fff',
    padding: '10px',
    color: '#AAA',
  },
});

const TextDivider = ({ children }) => {
  return (
    <Box sx={{ my: '2em' }}>
      <StyledTypography>
        <span>{children}</span>
      </StyledTypography>
    </Box>
  );
};

TextDivider.propTypes = {
  children: PropTypes.string,
};

export default TextDivider;
